import React, { useEffect, useState } from 'react'
import axios from 'axios'

import config from '../../variables/config'
import Loading from 'react-spinners/ClipLoader'

export default function menuModal({
  modalData,
  setMenuModal,
  setTriggerRefetch
}) {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    desc: [],
    price: '',
    tags: [],
    categories: [],
    note: ''
  })
  const [descVal, setDescVal] = useState('')
  const [tagsVal, setTagsVal] = useState('')
  const categories = [
    'Breakfast',
    'Pizzas',
    'Hot Food',
    'Jacket Potatoes',
    'Burgers',
    "Kid's Menu",
    'Paninis',
    'Omelettes',
    'Wraps',
    'Sandwiches & Baguettes',
    'Pastries & Cakes',
    'Snacks',
    'Drinks',
    'Cold Drinks'
  ]

  const domain = config.serverURL + '/menuItems'
  const token = JSON.parse(window.localStorage.getItem('userData')).token

  useEffect(() => {
    if (modalData.price) {
      setFormData({ ...modalData, price: (modalData.price / 100).toFixed(2) })
    } else setFormData(modalData)
    window.scrollTo(0, 0)
  }, [])

  const handleChange = (val, prop) => {
    if (prop !== 'categories') {
      setFormData(formData => {
        return { ...formData, [prop]: val }
      })
    } else {
      const newCategories = formData.categories
        ? [...formData.categories, val]
        : [val]
      setFormData(formData => {
        return { ...formData, categories: newCategories }
      })
    }
  }

  const addToNestedArr = (val, prop, stateCb) => {
    if (val) {
      const newFormData = formData[prop]
        ? { ...formData, [prop]: [...formData[prop], val] }
        : { ...formData, [prop]: [val] }
      setFormData(newFormData)
      stateCb('')
    }
  }

  const handleDelete = (index, prop) => {
    const newPropItems = [
      ...formData[prop].slice(0, index),
      ...formData[prop].slice(index + 1)
    ]
    setFormData(formData => {
      return { ...formData, [prop]: newPropItems }
    })
  }

  const handleSubmit = async index => {
    setLoading(true)
    const formattedFormData = {
      ...formData,
      price: Number(formData.price) * 100
    }

    try {
      if (formData.id === 'new') {
        delete formattedFormData.id
        const response = (await axios.post(
          `${domain}?token=${token}`,
          formattedFormData
        )).data
      } else {
        const response = (await axios.patch(
          `${domain}/${formData.id}?token=${token}`,
          formattedFormData
        )).data
      }
      setTriggerRefetch(true)
      setMenuModal(null)
    } catch (err) {
      alert(
        'Error saving values, please make sure you have all the required values'
      )
    }
    setLoading(false)
  }
  return (
    <div className="menuModal">
      <div className="headerContainer">
        <h1>{modalData.id === 'new' ? 'Add Menu Item' : 'Edit Menu Item'}</h1>
        <button onClick={() => setMenuModal(false)}>Back to menu</button>
      </div>
      <div className="formItem">
        <label htmlFor="name">* Name:</label>
        <input
          id="name"
          onChange={e => handleChange(e.target.value, 'name')}
          value={formData.name}
        />
      </div>

      <div className="formItem">
        <label htmlFor="desc">Description:</label>
        <textarea
          id="desc"
          rows="4"
          cols="65"
          value={descVal}
          onChange={e => setDescVal(e.target.value)}
        />
        <button
          className="addBtn"
          onClick={() => addToNestedArr(descVal, 'desc', setDescVal)}>
          Add Description
        </button>
        {formData.desc &&
          formData.desc.map((item, index) => (
            <div key={item} className="category">
              <p>{item}</p>{' '}
              <button onClick={() => handleDelete(index, 'desc')}>X</button>
            </div>
          ))}
      </div>

      <div className="formItem">
        <label htmlFor="price">* Price:</label>
        <span>
          <i>£ &nbsp;</i>
          <input
            id="price"
            onChange={e => handleChange(e.target.value, 'price')}
            value={formData.price}
          />
        </span>
      </div>
      <div className="formItem">
        <label htmlFor="image">Image:</label>
        <input id="image" type="file" />
      </div>
      <div className="formItem">
        <label htmlFor="tags">Tags (seperated by commas):</label>
        <input
          id="tags"
          onChange={e => setTagsVal(e.target.value)}
          value={tagsVal}
        />
        <button
          className="addBtn"
          onClick={() => addToNestedArr(tagsVal, 'tags', setTagsVal)}>
          Add Tag
        </button>
        {formData.tags &&
          formData.tags.map((item, index) => (
            <div key={item} className="category">
              <p>{item}</p>{' '}
              <button onClick={() => handleDelete(index, 'tags')}>X</button>
            </div>
          ))}
      </div>
      <div className="formItem">
        <label htmlFor="categories">Categories:</label>
        <select
          id="categories"
          onChange={e => handleChange(e.target.value, 'categories')}>
          <option>Select Categories</option>
          {categories.map(item => (
            <option key={`select-${item}`} value={item}>
              {item}
            </option>
          ))}
        </select>
        {formData.categories &&
          formData.categories.map((item, index) => (
            <div key={item} className="category">
              <p>{item}</p>{' '}
              <button onClick={() => handleDelete(index, 'categories')}>
                X
              </button>
            </div>
          ))}
      </div>
      <div className="formItem">
        <label htmlFor="note">Note:</label>
        <textarea
          id="note"
          rows="4"
          cols="65"
          onChange={e => handleChange(e.target.value, 'note')}
          value={formData.note}
        />
      </div>
      <button onClick={handleSubmit}>
        Save Changes{' '}
        {loading && (
          <Loading
            loading={loading}
            size={20}
            color="lightBlue"
            css={{ marginLeft: '10px' }}
          />
        )}
      </button>
    </div>
  )
}
